<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import type { AdminUserFiltersType } from '@/types/filters/AdminFilters'
import DebouncedInputField from '../../Fields/DebouncedInputField.vue'

type Props = {
    name?: string
    email?: string
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: AdminUserFiltersType): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="full-width" isResponsiveSmallScreen>
        <DebouncedInputField
            :label="$t('user.filters.name')"
            :modelValue="name"
            @change="$emit('change', { name: $event })" />
        <DebouncedInputField
            :label="$t('user.filters.email')"
            :modelValue="email"
            @change="$emit('change', { email: $event })" />
        <slot />
    </StackLayout>
</template>
